const percentFn = (value, decimals = 2, includePctSign = true) => {
  const pctSign = includePctSign ? '%' : ''
  if (!value) value = 0
  return Math.round((value * 100) * Math.pow(10, decimals)) / Math.pow(10, decimals) + pctSign
}

// if multiple functions in this category, add them to the list!
export default {
  percent: percentFn
}

export const formatAsPercent = percentFn
